import React, { useEffect, useRef } from 'react';
import { IoMdSend } from 'react-icons/io';
import chatbot from '../../../src/assets/chatbot.png';
import { useSocket } from '../../Contexts/SocketContext';

const ChatArea = ({
  selectedUserHistory,
  selectedUser,
  inputValue,
  setInputValue,
  handleAddMsg,
  formatChatTime,
  handleEndChat
}: any) => {
  const messagesContainerRef = useRef<HTMLDivElement | null>(null);
  const { socketInstance } = useSocket();

  const userUUID = sessionStorage.getItem('userUUID');

  const handleSendMessage = () => {
    try {
      if (inputValue) {
        if (socketInstance) {
          const payload = {
            message: inputValue,
            customerUuid: selectedUser.customerUuid,
            userUuid: userUUID,
            conversationUuid: selectedUser.id
          };
          socketInstance.emit('user-to-customer-message', payload);
          handleAddMsg();
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleKeyPress = (e: any) => {
    if (inputValue !== '') {
      if (e.key === 'Enter') handleSendMessage();
    }
  };

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  }, [selectedUserHistory]);

  return (
    <div className="xl:h-[calc(100vh-160px)] flex flex-col gap-3 bg-[#343434] p-2 xl:p-2 rounded-lg  max-w-[639px] sm:max-w-[767px] md:max-w-[800px] lg:max-w-[800px] mx-auto">
      <div className="flex items-center p-2 justify-between">
        <div className="gap-3 flex items-center">
          <div className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-500 text-white font-bold text-sm">
            {selectedUser?.name.length > 0 && selectedUser.name[0]}
          </div>
          <span className="text-white font-medium text-base">{selectedUser?.name}</span>
        </div>
        {(selectedUser.status === null || selectedUser.status === 'Open') && (
          <button
            type="button"
            onClick={handleEndChat}
            className="self-start py-1.5 px-2.5 bg-[#FF4C4C] text-[#FFFFFF] rounded-[7px] text-sm font-bold shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
          >
            End Chat
          </button>
        )}
      </div>
      <div className="border-b-2 border-[#69696980]"></div>
      <div
        ref={messagesContainerRef}
        className="flex-grow h-[40vh] overflow-y-auto flex flex-col gap-4 p-2"
      >
        {selectedUserHistory?.map((message: any, index: number) => (
          <div
            key={index}
            className={`flex ${message.senderType === 'System' ? 'items-start gap-3' : 'justify-end'}`}
          >
            {message.senderType === 'System' && (
              <div className="w-[35px] lg:w-8 lg:h-6 flex items-center justify-center rounded-full ">
                <span className="text-white text-sm md:text-lg">
                  <img src={chatbot} alt="chatbot" />
                </span>
              </div>
            )}
            <div
              className={`${
                message.senderType === 'System'
                  ? 'bg-gray-100 text-gray-800 lg:max-w-[60%] max-w-[55%]'
                  : 'bg-blue-500 text-white lg:max-w-[50%] max-w-[50%]'
              } py-1 px-2 rounded-md shadow-md break-words whitespace-normal`}
            >
              <p className="w-full break-all text-xs md:text-xs">{message.message}</p>
              <span className="text-[#343434] text-[10px] block text-right mt-1 ml-5">
                {formatChatTime(message.createdAt)}
              </span>
            </div>
          </div>
        ))}
      </div>

      {(selectedUser.status === null || selectedUser.status === 'Open') && (
        <div className="flex items-center gap-1 bg-[#B3B3B3] p-1 rounded-full">
          <input
            type="text"
            placeholder="Message Support Bot"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyPress}
            className="flex-grow p-1 lg:p-1 lg:px-2 rounded-full bg-[#B3B3B3] text-black placeholder-[#6E6E6E] focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-sm text-sm"
          />
          <button
            className={`p-1 lg:p-2 rounded-full text-white ${inputValue ? 'bg-blue-500 hover:bg-blue-600' : 'bg-slate-600'}`}
            onClick={handleSendMessage}
            disabled={inputValue ? false : true}
          >
            <IoMdSend size={12} />
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatArea;
